export default "__VITE_ASSET__CGjMuT1W__"